import { render } from "./submission-panel-tabs.vue?vue&type=template&id=2799c016&scoped=true&ts=true"
import script from "./submission-panel-tabs.vue?vue&type=script&lang=ts"
export * from "./submission-panel-tabs.vue?vue&type=script&lang=ts"

import "./submission-panel-tabs.vue?vue&type=style&index=0&id=2799c016&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2799c016"]])

export default __exports__